import React from 'react';
import { HOME_TYPE } from '../../../../../../constants/service/app/widgetConstants';
import PageWidgetInfo from '../HomeWidgetInfo';
import HomeWidgetList from '../HomeWidgetList';
import './HomeWidgetListWrap.scss';

const HomeWidgetListWrap = (props) => {
  const {
    homeType,
    pageWidgetList,
    setData,
    getList,
    saveWidgetList,
    onChangeBulkWidgetPeriod,
    getWidgetPreviewData,
    onChangeWidgetStatus,
    onChangeWidgetNo,
    widgetPreviewCompare,
    getInactiveWidgetList,
  } = props;

  return (
    <div className="home-widget-list-wrap">
      {homeType === HOME_TYPE.SUB ? (
        <PageWidgetInfo
          setData={setData}
          widgetPageInfo={pageWidgetList.widgetPageInfo}
          originalWidgetPageInfo={pageWidgetList.originalWidgetPageInfo}
        />
      ) : null}

      {/* 위젯 리스트 */}
      <HomeWidgetList
        setData={setData}
        pageWidgetList={pageWidgetList}
        getList={getList}
        homeType={homeType}
        saveWidgetList={saveWidgetList}
        onChangeBulkWidgetPeriod={onChangeBulkWidgetPeriod}
        onChangeWidgetStatus={onChangeWidgetStatus}
        onChangeWidgetNo={onChangeWidgetNo}
        getWidgetPreviewData={getWidgetPreviewData}
        getInactiveWidgetList={getInactiveWidgetList}
        widgetPreviewCompare={widgetPreviewCompare}
      />
    </div>
  );
};

export default HomeWidgetListWrap;
